import React from "react";
import { udfFields } from "../formFields/shippmentTabsFields";
import GenericFormTab from "./GenericFormTab"; // adjust path

export default function UdfTab({ formData, onChange , errors = {} , viewOnly = false , isEdit = true }) {
    return <GenericFormTab fields={udfFields} formData={formData} onChange={onChange} errors={errors} readOnly={viewOnly} isEdit={isEdit} />;
}
